import React, { Fragment, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useCart } from "react-use-cart";
import "./style.css";
import { useArgusAuth } from "../../hooks/useArgusAuth";
import MobileHeader from "../MobileHeader";
import DesktopHeader from "../DesktopHeader";
import { ScreenSize, AccountType } from "../../utils/constants";
import TabletHeader from "../TabletHeader";
import useSystemHook from "../../hooks/SystemHook";
import SavedVehiclesModal from "../SavedVehiclesModal";
import SavedVehicleModal from "../SavedVehicleModal";
import ChooseVehicleModal from "../ChooseVehicleModal";

const modal_name = {
  savedVehicle: "savedVehicle",
  savedVehicles: "savedVehicles",
  chooseVehicle: "chooseVehicle",
  announcement: "announcement",
};

const SiteHeader = ({
  genericPageContent,
  genericDataLoaded,
  categoriesAndTypes,
  activateUserVehicleAsync,
  createUserVehicleAsync,
  removeUserVehicleAsync,
}) => {
  const { logout, loginWithRedirect, isAuthenticated, isLoading } = useArgusAuth();
  const navigate = useNavigate();
  const { totalItems } = useCart();
  const { screenSize } = useSystemHook();

  const [openModal, setOpenModal] = useState("");
  const location = useLocation();
  const [totalGarageItems, setTotalGarageItems] = useState(0);

  const accountType =
    genericPageContent?.accountType === AccountType.Commercial
      ? "Trade"
      : genericPageContent?.accountType === AccountType.Retail
        ? "Retail"
        : genericPageContent?.accountType === AccountType.Guest
          ? "Guest"
          : "Unknown";

  const openSavedVehiclesModal = () => {
    if (openModal !== modal_name.savedVehicles) {
      setOpenModal(modal_name.savedVehicles);
    }
  };

  const openChooseVehicleModal = () => {
    if (openModal !== modal_name.chooseVehicle) {
      setOpenModal(modal_name.chooseVehicle);
    }
  };

  const closeModals = () => {
    setOpenModal("");
  };

  const gotoLoginPage = async () => {
    closeModals();
    const returnTo = location.pathname || "/";
    if (isAuthenticated === false) {
      await loginWithRedirect({
        appState: { returnTo },
      });
    }
  };

  const gotoCartPage = async () => {
    navigate("/cart");
  };

  const gotoRegistrationPage = async () => {
    closeModals();
    const returnTo = location.pathname || "/";
    if (isAuthenticated === false) {
      await loginWithRedirect({
        authorizationParams: {
          screen_hint: "signup",
        },
        appState: { returnTo },
      });
    }
  };

  const performLogout = async () => {
    await logout({ logoutParams: { returnTo: window.location.origin } });
  };

  useEffect(() => {
    if (genericPageContent?.userVehicles) {
      setTotalGarageItems(genericPageContent?.userVehicles.length);
    }
  }, [genericPageContent?.userVehicles]);

  return (
    <Fragment>
      {screenSize === ScreenSize.Mobile && (
        <MobileHeader
          performLogout={performLogout}
          gotoLoginPage={gotoLoginPage}
          gotoRegistrationPage={gotoRegistrationPage}
          gotoCartPage={gotoCartPage}
          openSavedVehiclesModal={openSavedVehiclesModal}
          cartItems={totalItems}
          totalGarageItems={totalGarageItems}
          categoriesAndTypes={categoriesAndTypes}
          customerCategory={genericPageContent.customerCategory}
          firstName={genericPageContent.firstName}
          lastName={genericPageContent.lastName}
          tecfinityAccountName={genericPageContent?.tecfinityAccountName}
          tecfinityAccountNumber={genericPageContent?.tecfinityAccountNumber}
          tecfinityAvailableCredit={
            genericPageContent?.tecfinityAvailableCredit
          }
          accountType={accountType}
        />
      )}
      {screenSize === ScreenSize.Tablet && (
        <TabletHeader
          performLogout={performLogout}
          gotoLoginPage={gotoLoginPage}
          gotoRegistrationPage={gotoRegistrationPage}
          gotoCartPage={gotoCartPage}
          cartItems={totalItems}
          totalGarageItems={totalGarageItems}
          categoriesAndTypes={categoriesAndTypes}
          openSavedVehiclesModal={openSavedVehiclesModal}
          customerCategory={genericPageContent.customerCategory}
          firstName={genericPageContent.firstName}
          lastName={genericPageContent.lastName}
          tecfinityAccountName={genericPageContent?.tecfinityAccountName}
          tecfinityAccountNumber={genericPageContent?.tecfinityAccountNumber}
          tecfinityAvailableCredit={
            genericPageContent?.tecfinityAvailableCredit
          }
          accountType={accountType}
        />
      )}
      {screenSize === ScreenSize.Desktop && (
        <DesktopHeader
          performLogout={performLogout}
          gotoLoginPage={gotoLoginPage}
          gotoRegistrationPage={gotoRegistrationPage}
          gotoCartPage={gotoCartPage}
          cartItems={totalItems}
          totalGarageItems={totalGarageItems}
          categoriesAndTypes={categoriesAndTypes}
          openSavedVehiclesModal={openSavedVehiclesModal}
          genericPageContent={genericPageContent}
          customerCategory={genericPageContent.customerCategory}
          firstName={genericPageContent.firstName}
          lastName={genericPageContent.lastName}
          tecfinityAccountName={genericPageContent?.tecfinityAccountName}
          tecfinityAccountNumber={genericPageContent?.tecfinityAccountNumber}
          tecfinityAvailableCredit={
            genericPageContent?.tecfinityAvailableCredit
          }
          accountType={accountType}
        />
      )}
      {openModal === modal_name.savedVehicles && (
        <SavedVehiclesModal
          open={openModal === modal_name.savedVehicles}
          setClose={closeModals}
          openChooseVehicleModal={openChooseVehicleModal}
          userVehicles={genericPageContent.userVehicles}
          currentUserVehicleId={genericPageContent.userVehicleId}
          activateUserVehicleAsync={activateUserVehicleAsync}
          removeUserVehicleAsync={removeUserVehicleAsync}
        />
      )}
      {openModal === modal_name.savedVehicle && (
        <SavedVehicleModal
          open={openModal === modal_name.savedVehicle}
          setClose={closeModals}
          openSavedVehiclesModal={openSavedVehiclesModal}
        />
      )}
      {openModal === modal_name.chooseVehicle && (
        <ChooseVehicleModal
          open={openModal === modal_name.chooseVehicle}
          setClose={closeModals}
          openSavedVehiclesModal={openSavedVehiclesModal}
          createUserVehicleAsync={createUserVehicleAsync}
        />
      )}
    </Fragment>
  );
};

export default SiteHeader;
